import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=5b496b1a&"
import script from "./ContactList.js?vue&type=script&lang=js&"
export * from "./ContactList.js?vue&type=script&lang=js&"
import style0 from "./ContactList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports